interface Props {
    title: string,
    textAlign: string,
    light: boolean
}

export const FormHeading = (props: Props) => {
    return (
        <div className={`formHeading ${props.light? 'light': ''}`}>
            <h4 className={`css_heading bold ${props.textAlign}`}>{props.title}</h4>
        </div>
    );
};